<template>
  <div id=''>
    <!--<div class='gPageBorder' v-loading='loading' v-show="false">-->
      <!--<el-form label-position="right" label-width="12.5%"  class='gForm' style=''>-->

        <!--<el-form-item :label="$t('app_pushType')">-->
          <!--<el-select style='' v-model="pType" :placeholder="$t('app_select')" @change=''>-->
            <!--<el-option-->
              <!--v-for="item in types"-->
              <!--:key="item.value"-->
              <!--:label="item.label"-->
              <!--:value="item.value">-->
            <!--</el-option>-->
          <!--</el-select>-->
        <!--</el-form-item>-->

        <!--<el-form-item v-show="pType === '0'" :label="$t('app_distributor')">-->
          <!--&lt;!&ndash;<el-select style='' v-model="choose" :placeholder="$t('app_select')" @change='selected'>&ndash;&gt;-->
            <!--&lt;!&ndash;<el-option&ndash;&gt;-->
              <!--&lt;!&ndash;v-for="item in channels"&ndash;&gt;-->
              <!--&lt;!&ndash;:key="item"&ndash;&gt;-->
              <!--&lt;!&ndash;:label="item.mechanismname"&ndash;&gt;-->
              <!--&lt;!&ndash;:value="item">&ndash;&gt;-->
            <!--&lt;!&ndash;</el-option>&ndash;&gt;-->
          <!--&lt;!&ndash;</el-select>&ndash;&gt;-->
          <!--<MechanismSelector :data="mechanismData" :mselect="true" ></MechanismSelector>-->
        <!--</el-form-item>-->

        <!--<el-form-item v-if="pType === '1'" :label="$t('app_mdFile')">-->

            <!--<a class='aSc' style='' :href="downUrl" :title="$t('app_downExp')" target="_blank">{{$t('app_downExp')}}</a>-->

            <!--<el-upload-->
              <!--class="upload-demo"-->
              <!--name='fileUpload'-->
              <!--:action="$fileExcelUlUrl"-->
              <!--:before-upload="srcBefore"-->
              <!--:on-success="srcSuccess"-->
              <!--:file-list="srcList">-->
              <!--<el-button size="small" type="primary">{{$t('app_clickUpdate')}}</el-button>-->
            <!--</el-upload>-->
        <!--</el-form-item>-->

        <!--<el-form-item :label="$t('app_deviceNo')" v-show="pType === '2'">-->
          <!--&lt;!&ndash; <el-input v-model='dvNo' :placeholder="$t('app_plsip')"></el-input> &ndash;&gt;-->
          <!--<AutoTerno @on-result-change="onDvInputChange"></AutoTerno>-->
        <!--</el-form-item>-->

        <!--<el-form-item :label="$t('app_deviceNum')" v-show="pType !== '2'">-->
          <!--<el-label style='width:25%;'>{{devices}}{{$t('app_amechine')}}</el-label>-->
        <!--</el-form-item>-->

        <!--<el-form-item label="">-->
          <!--<el-button style='' @click='cancel'>{{$t('app_cancel')}}</el-button>-->
          <!--<el-button type=primary style='' @click='pushAnimate'>{{$t('app_push')}}</el-button>-->
        <!--</el-form-item>-->

      <!--</el-form>-->
    <!--</div>-->

    <div class='gPageBorder pushObjectDetail'>
      <div class="title">{{info.animatName}}</div>
      <el-row :gutter="20" class="detail">
        <el-col :span="6"><label>动画类型:</label>{{aType[info.animatType]}}</el-col>
        <el-col :span="6"><label>动画大小:</label>{{info.size}}</el-col>
        <el-col :span="6"><label>渠道商:</label>无</el-col>
        <el-col :span="6"><label>上传时间:</label>{{info.createTime}}</el-col>
      </el-row>
      <!--<div class="mark"><label>sdf</label></div>-->
    </div>

    <div class='gTopMg gPageBorder' v-loading='pLoading'>
      <p class='gPTitle'>{{$t('app_pushHistory')}}</p>
      <div class="subTitle_buttonBar">
        <el-button size="small" @click="jumpToPush()">添加推送</el-button>
        <el-button size="small">批量还原({{multipleSelection.length || 0}})</el-button>
      </div>
      <div id=''>
        <el-table
        @row-click='cellClick'
        @selection-change="handleSelectionChange"
        :data="tableData"
        border
        tooltip-effect="dark"
        style="width: 100%">
          <el-table-column
            type="selection"
            width="55">
          </el-table-column>
          <el-table-column
            align=center
            prop='mechanismName'
            :label="$t('app_distributor')"
            width="">
          </el-table-column>
          <el-table-column
            align=center
            prop="nums"
            :label="$t('app_deviceNum')"
            width="">
          </el-table-column>
          <el-table-column
            align=center
            prop="pushTime"
            :label="$t('app_pushTime')"
            width=''>
          </el-table-column>
          <el-table-column
            prop="operate"
            align=center
            :label="$t('app_operate')"
            width='80'>
            <template slot-scope='scope'>
              <!-- <el-button type='text' @click='deleteRow(scope.row)'>{{$t('app_clear')}}</el-button> -->
              <el-tooltip class="item" effect="dark" :content="$t('app_clear')" placement="top">
                <el-button type='text' ><i class="fa fa-trash-o" style="color:#FF4949"></i></el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <paging :rdata="pagingData" :action="pAction"></paging>
      <!-- 分页 END -->
      <div style="height:1px;margin-bottom: 20px;"></div>
    </div>



  </div>
</template>

<style scoped lang="less">
  /*.subTitle_buttonBar {*/
    /*padding: 16px 24px;*/
  /*}*/
  /*.pushObjectDetail {*/
    /*padding: 10px 16px 20px 16px;*/
    /*!*padding-bottom: 10px;*!*/
    /*.title {*/
      /*font-size: 15px;*/
      /*height:40px;*/
      /*line-height: 40px;*/
      /*font-weight: bold;*/
    /*}*/
    /*.detail {*/
      /*margin-top: 10px;*/
      /*!*padding-bottom: 10px;*!*/
      /*.el-col > label {*/
        /*margin-right: 5px;*/
        /*color: #acbbc7;*/
      /*}*/
    /*}*/
  /*}*/
</style>

<script>
  import MechanismSelector from '@/components/global/mechanism_selector.vue'
  import AutoTerno from '../../global/TernoAutoCtrl'
  import MPage from '@/components/global/paging.vue'
  export default{
    components: {
      paging: MPage,
      MechanismSelector,
      AutoTerno
    },
    data () {
      var that = this
      return {
        mechanismData: {
          value: null,
          placeholder: that.$t('lin_global.place_areaid'),
          callback (value) {
            that.choose = {"mechanismid": value}
            that.selected({"mechanismid": value})
          }
        },
        pagingData: {
          total: 0,
          pageSize: 20,
          currentPage: 1
        },
        aType: {'1': this.$t('app_launchAnimate'), '2': this.$t('app_onLogo')},
        dvNo: '',
        srcList: [],
        types: [
          {label: this.$t('app_distributor'), value: '0'},
          {label: this.$t('app_fileImport'), value: '1'},
          {label: this.$t('app_sgMc'), value: '2'}
        ],
        pType: '0',
        channels: [],
        choose: '',
        info: '',
        loading: 0,
        devices: 0,
        exInfo: {},
        // pushed
        row: this.$gRow,
        total: 0,
        page: 1,
        tableData: [],
        //info: '', 共用
        pLoading: 0,
        multipleSelection: []
      }
    },
    computed: {
      downUrl () {
        return this.$host + '/tms-server-web/model/terminalNos.xlsx'
      }
    },
    methods: {
      handleSelectionChange (val) {
        this.multipleSelection = val
      },
      pAction () {

      },
      cellClick () {

      },
      jumpToPush () {
        //任务类型:1.应用推送； 2.OTA推送； 3.ROM推送； 4.固件推送； 5.广告推送； 6.动画推送； 10.launcher推送。
        location.hash = '#/animate-push/push/6'
      },
      getList () {
        let that = this
        var aId = this.info.animatId
        this.pLoading = 0
        let params = {
          page: that.pagingData.currentPage,
          rows: that.pagingData.pageSize,
          fileId: this.info.animatId
        }
        this.$getPushHistory(params, (res) => {
          this.pLoading = 0
          if (res.status === 200) {
            this.tableData = res.data
            that.pagingData.total = res.total
          }
        }, () => {
          this.pLoading = 0
        })
//        this.$pushAnimateHistory(aId, (res) => {
//          this.pLoading = 0
//          if (res.status === 200) {
//            this.tableData = res.data
//          }
//        }, () => {
//          this.pLoading = 0
//          // error
//        })
      },
    },
    mounted () {
//      this.getChannel()
      this.info = this.$getWObj().animatePushInfo
      this.getList()
    }
  }
</script>



// WEBPACK FOOTER //
// push.vue?52145e7c